"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

var PlayIcon = function PlayIcon(_a) {
  return React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("polyline", {
    points: "4.243,2.685 4.243,13.315 11.757,8 4.243,2.685"
  })));
};

exports["default"] = PlayIcon;